//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import addGame from "./components/addGame";
export default {
  name: "gameList",
  mixins: [loadMoreList],
  components: {
    addGame: addGame
  },
  data: function data() {
    return {
      pagingReqFn: "gameList",
      pagingReqValue: "list"
    };
  },
  mounted: function mounted() {},
  activated: function activated() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'delGame',
        data: {
          id: [data.id]
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};